import React from 'react';
import { useTranslation } from 'react-i18next';

import TrackerColumn from '../TrackerColumn/TrackerColumn';

import styles from './TrackerBoardView.module.scss';

// Column config varies by direction (my / their)
const getStatusConfig = (direction) => ({
  new: {
    labelKey: direction === 'their' ? 'tracker.new' : 'tracker.received',
    fallback: direction === 'their' ? 'New' : 'Received',
    color: '#6dccb1',
  },
  applied: {
    labelKey: 'tracker.applied',
    fallback: 'Applied',
    color: '#79aad9',
  },
  interview: {
    labelKey: 'tracker.interviewing',
    fallback: 'Interviewing',
    color: '#f1d86f',
  },
  archived: {
    labelKey: 'tracker.closedOutcomes',
    fallback: 'Closed / Outcomes',
    color: '#d3dae6',
  },
});

const TrackerBoardView = ({ columns, direction, isLoading }) => {
  const { t } = useTranslation('common');
  const statusConfig = getStatusConfig(direction);

  return (
    <div className={styles.boardGrid}>
      {columns.map((col) => {
        const config = statusConfig[col.status] || statusConfig.new;
        return (
          <TrackerColumn
            key={col.status}
            title={t(config.labelKey, config.fallback)}
            status={col.status}
            jobs={col.jobs}
            count={col.count}
            color={config.color}
            direction={direction}
            isLoading={col.isLoading || isLoading}
            
          />
        );
      })}
    </div>
  );
};

export default TrackerBoardView;
